export const GETTERS_LIST_REQUIREMENT_ITEMS = "GETTERS_LIST_REQUIREMENT_ITEMS";

export const ACTIONS_SET_LIST_REQUIREMENT_ITEMS =
  "ACTIONS_SET_LIST_REQUIREMENT_ITEMS";
export const ACTIONS_ADD_REQUIREMENT_ITEMS = "ACTIONS_ADD_REQUIREMENT_ITEMS";
export const ACTIONS_EDIT_REQUIREMENT_ITEMS = "ACTIONS_EDIT_REQUIREMENT_ITEMS";
export const ACTIONS_DELETE_REQUIREMENT_ITEMS =
  "ACTIONS_DELETE_REQUIREMENT_ITEMS";

export const MUTATIONS_SET_LIST_REQUIREMENT_ITEMS =
  "MUTATIONS_SET_LIST_REQUIREMENT_ITEMS";



// WEBPACK FOOTER //
// ./src/store/modules/basic_program_requirement_items/constants.js